import { Component } from '@angular/core';
import { GoogleTranslateComponent } from '../../../../google-translate/google-translate.component';

@Component({
  selector: 'ppl-footer',
  standalone: true,
  imports: [GoogleTranslateComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

}
